
import { Vue, Options } from "vue-class-component";
import Page from "../molecules/Page.vue";
import { Prop } from "vue-property-decorator";
import { PropType } from "vue";
import ActionButton from "../atoms/ActionButton.vue";
import { OperationRangesEnum } from "../../autogen";
import HelpIcon from "../atoms/HelpIcon.vue";

@Options({
  components: {
    Page,
    ActionButton,
    HelpIcon
  }
})
export default class AuthorityTable extends Vue {
  @Prop({ type: Array as PropType<Object> }) datas: Object[] = [];
  @Prop({ type: Array as PropType<Array<Object>> }) headers: Object[][] = [];

  get operationRanges() {
    return OperationRangesEnum;
  }

  systemDefined(id: string): boolean {
    return ["1", "2", "3", "4"].includes(id);
  }
}
